import { contactsApi } from 'app/src/services/welfareportal'
import { NavigatePaths, useWebAppContext } from 'app/src/shared/hooks'
import { Button } from 'primereact/button'
import { Sidebar } from 'primereact/sidebar'
import { useTranslation } from 'react-i18next'

export function ContactUsSidePanel() {
  const context = useWebAppContext()
  const { t } = useTranslation('home')
  const contactResponse = contactsApi.useContactsRequestList(
    { pathParams: { templateBasePath: context.userInfo.welfareCampaign.configuration.frontend.templateId } },
    { throwOnError: false },
  )

  return (
    <div className='card justify-content-center'>
      <Sidebar
        className='w-[370px]'
        visible={context.showContactUs}
        position={'right'}
        onHide={() => context.update({ showContactUs: false })}
      >
        <p className='text-[32px] font-bold leading-[48px]'>{t('AppBar.ContactUs')}</p>
        <p className='text-[16px] font-normal leading-[24px]'>{t('AppBar.ContactUsSubTitle')}</p>
        <br />

        {Array.isArray(contactResponse?.data) &&
          // contactResponse?.data?.map((info, index) => (
          contactResponse?.data?.map((info) => (
            <div key={info.id}>
              <div className='grid grid-cols-12'>
                <div className='col-span-10 col-start-3 font-bold md:col-span-10 md:col-start-3'>{info.title}</div>
              </div>
              <div className='grid grid-cols-12'>
                <div className='col-span-2 col-start-1 md:col-span-2 md:col-start-1'>
                  <i className={`${info.imageSrc} h-[64px] w-[64px] content-center text-3xl`} />
                </div>
                <div className='col-span-10 col-start-3 text-[16px] md:col-span-10 md:col-start-3'>{info.body}</div>
              </div>
              {info.footerText && (
                <div className='grid grid-cols-12'>
                  <div className='col-span-9 col-start-3 md:col-span-9 md:col-start-3'>
                    <Button
                      link
                      // autoFocus={index === 0}
                      label={footerText(info.footerText, context.userInfo.welfareCampaign.configuration.frontend?.contactInfo)}
                      // icon={info.footerIcon}
                      iconPos='left'
                      className='custom-focus break-all px-1 text-left'
                      onClick={() => (window.location.href = info.footerText!)}
                    />
                  </div>
                </div>
              )}
              <br />
            </div>
          ))}

        <div>
          <div className='grid grid-cols-12'>
            <div className='col-span-2 col-start-1 md:col-span-2 md:col-start-1'>
              <i className='pi pi-info-circle h-[64px] w-[64px] content-center text-3xl' />
            </div>
            <div className='col-span-10 col-start-3 flex flex-col font-bold md:col-span-10 md:col-start-3'>
              <span>Come utilizzare la piattaforma</span>
              <Button
                link
                label={'Vai alla sezione'}
                iconPos='left'
                className='custom-focus break-all px-1 text-left'
                onClick={() => {
                  window.location.href = `/#${NavigatePaths.Tutorial}`
                  context.update({ showContactUs: false })
                }}
              />
            </div>
          </div>
        </div>
      </Sidebar>
    </div>
  )
}

function footerText(footerText: string, contactInfo?: { email?: string; phone?: string }): string {
  if (footerText.includes('mailto:') && contactInfo?.email) {
    return contactInfo.email
  }
  if (footerText.includes('tel:') && contactInfo?.phone) {
    return contactInfo.phone
  }
  return footerText.replace(/mailto:|tel:/g, '')
}
